import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJSON from "./en.json";
import esJSON from "./es.json";
import frJSON from "./fr.json";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { ...enJSON },
      es: { ...esJSON },
      fr: { ...frJSON },
    },
    fallbackLng: "en",
    detection: {
      order: ["navigator", "localStorage", "sessionStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
